import { Fragment, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { Checkbox } from 'primereact/checkbox';
import { InputNumber } from 'primereact/inputnumber';

import { InvoiceService as Service } from './InvoiceService';
import { RegisterInvoiceService } from '../../service/invoice/RegisterInvoiceService';
import { CurrencyService } from '../danh-muc/tien-te/CurrencyService';
import { AppConfigService } from '../../service/AppConfigService';

import { useToolbar } from '../../shared/hooks/Toolbar';
import { useDataTable } from '../../shared/hooks/DataTable';
import { useDialogImportExcel } from './item/DialogImportExcel';
import { DialogCrup } from './component/DialogCrup';
import { DialogCrupXangDau } from './component/DialogCrupXangDau';
import { DialogView } from './component/DialogView';
import { DialogViewMulti } from './component/DialogViewMulti';
import { DialogCancel } from './component/DialogCancel';
import { DialogSendEmail } from './component/DialogSendEmail';
import { DialogViewTransferLog } from './component/DialogViewTransferLog';
import { DialogSignInvoice } from './component/DialogSignInvoice';
import { DialogViewHistory } from './component/DialogViewHistory';
import { TenantSettingService } from '../he-thong/tham-so-he-thong/TenantSettingService';
import { Sign, useSign } from '../../shared/component/Sign';
import { ConfirmDialogService } from '../../AppConfirmDialog';
import { ROLE } from '../../Constant';
import { AppStorage } from '../../service/UserStorage';
import EventEmitter from '../../utils/EventEmitter';
import { useDialogSyncInvoice } from './item/DialogSyncInvoice';
import { useDialogChangeInvoiceSerial } from './item/DialogChangeSerial';
import { useDialogTaxAuthStatus } from './item/DialogTaxAuthStatus';
import { FormatDisplay } from '../../shared/format';
import { MGateWayService } from '../lich-su-truyen-nhan/MGateWayService';
import moment from 'moment';
import { ToastService } from '../../AppToast';
import { Dialog } from 'primereact/dialog';
import { DialogSelectInvoiceDiscounted } from './component/DialogSelectInvoiceDiscounted';
import DialogDiscountInvoiceAttachment from './component/DialogDiscountInvoiceAttachment';

export const List = () => {
  let permissionString = AppStorage.get('pk');
  let userName = AppStorage.get('UserName');
  let permissions = JSON.parse(permissionString) || [];
  let actionFunction = null;
  let registerInvoiceViewId = null;
  let actionMenuErrorProcessing = null;
  let selectedRecords = null;
  let functionActions = [];
  let mitileSignActions = [];
  let errorProcessingAction = [];
  const header = 'Hóa đơn';
  const deleteRole = ROLE.INVOICE_MANAGEMENT_DELETE;
  const createRole = ROLE.INVOICE_MANAGEMENT_CREATE;
  const editRole = ROLE.INVOICE_MANAGEMENT_EDIT;
  const cloneRole = ROLE.INVOICE_MANAGEMENT_COPY;
  const importRole = ROLE.INVOICE_MANAGEMENT_FEATURES_UPLOADEXCEL;
  const exportRole = ROLE.INVOICE_MANAGEMENT_FEATURES_DOWNLOADXML;
  const dataKey = 'id';

  const { search } = useLocation();
  const [showIconHitoryChange, setShowIconHitoryChange] = useState(false);
  const [registerInvoiceId, setRegisterInvoiceId] = useState(null);
  const [registerId, setRegisterId] = useState(null);
  const [registerInvoice, setRegisterInvoice] = useState(null);
  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [requiredParams, setRequiredParams] = useState(null);

  const [currencies, setCurrencies] = useState(null);
  const [paymentTypes, setPaymentTypes] = useState(null);

  const [displayView, setDisplayView] = useState(false);
  const [displayViewMulti, setDisplayViewMulti] = useState(false);
  const [displayCrup, setDisplayCrup] = useState(false);
  const [displayCrupXangDau, setDisplayCrupXangDau] = useState(null);
  const [displayCancel, setDisplayCancel] = useState(false);
  const [displaySendEmail, setDisplaySendEmail] = useState(false);
  const [transferLogItem, setTransferLogItem] = useState(false);
  const [displayTransferLog, setDisplayTransferLog] = useState(false);
  const [invoiceStatus, setInvoiceStatus] = useState(0);
  const [displayHistoryItem, setDisplayHistoryItem] = useState(null);
  const [displayHistory, setDisplayHistory] = useState(false);
  const [displaySelectInvoiceDiscounted, setDisplaySelectInvoiceDiscounted] = useState(false)
  const [displayDiscountInvoiceAttachment, setDisplayDiscountInvoiceAttachment] = useState(false)
  const [selectInvoiceDiscounted, setSelectInvoiceDiscounted] = useState([])
  const [columns, setColumns] = useState([]);
  const [columnsState, setColumnsState] = useState(0);
  const [columnConfigOrigin, setColumnConfigOrigin] = useState(null);
  const [columnConfig, setColumnConfig] = useState(null);
  const [columnConfigSum, setColumnConfigSum] = useState(null);
  const [footerColumnGroup, setFooterColumnGroup] = useState(null);
  const [actionPermision, setActionPermision] = useState([]);
  const [showIconView, setShowIconView] = useState(true);
  const [showIconCopy, setShowIconCopy] = useState(true);
  const [showIconPrint, setShowIconPrint] = useState(true);
  const [showIconSendEmail, setShowIconSendEmail] = useState(true);
  const [sendType, setSendType] = useState(1);
  const [showIconSign, setShowIconSign] = useState(true);
  const [displaySignInvoice, setDisplaySignInvoice] = useState(true);
  const [displaySelectInvoice, setDisplaySelectInvoice] = useState(null);
  const [systemStatus, setSystemStatus] = useState(["", "Ký hóa đơn xml lỗi", "Hoàn tác, Lỗi trong quá trình gửi hóa đơn ký số điện tử, Vui lòng ký và gửi lại hóa đơn", "Hoàn tác, Lỗi trong quá trình gửi hóa đơn tới cơ quan thuế, Vui lòng ký và gửi lại hóa đơn"]);
  const [idInvoiceListDiscount, setIdInvoiceListDiscount] = useState()
  const [relatedInvoiceProperty, setRelatedInvoiceProperty] = useState(null)
  useEffect(() => {
    setDisableIconAction();
    TenantSettingService.getList({ key: TenantSettingService.key.BAT_LUU_LICH_SU_THAY_DOI_HOA_DON }).then(({ items, totalCount }) => {
      if (totalCount > 0) {
        setShowIconHitoryChange(items[0].value === 'C');
      }
    }).finally(() => {
      RegisterInvoiceService.getUsingList({ maxResultCount: 1000, userName, Sorting: 'creationTime', SortType: 'DESCEND' }).then(({ items }) => {
        const _registerInvoices = [];
        items.forEach(item => {
          item.label = `${item.symbolCode} - ${item.invoiceTypeName}`;
          _registerInvoices.push(item);
        });
        setRegisterInvoices(_registerInvoices);
      });
      CurrencyService.getList({ maxResultCount: 1000 }).then(({ items }) => {
        setCurrencies(items);
      });
      Service.getPaymentTypes().then(({ items }) => {
        const _paymentTypes = [];
        items.forEach(item => {
          _paymentTypes.push({ value: item.name, label: item.name });
        });
        setPaymentTypes(_paymentTypes);
      });
    });
  }, []);

  useEffect(() => {
    if (search) {
      const params = new URLSearchParams(search);
      const registerInvoiceId = params.get('registerInvoiceId');
      if (registerInvoiceId) {
        setRegisterInvoiceId(registerInvoiceId);
        setRegisterId(registerInvoiceId);
        registerInvoiceViewId = registerInvoiceId;
      }
    }
  }, [search]);

  useEffect(() => {
    let setDefault = true;
    if (search && registerInvoices?.length) {
      const params = new URLSearchParams(search);
      const invoiceSerial = params.get('invoiceSerial');
      if (invoiceSerial) {
        const _registerInvoice = registerInvoices.find(it => it.symbolCode === invoiceSerial);
        if (_registerInvoice) {
          setRegisterInvoice(_registerInvoice);
          setDefault = false;
        }
      }
    }
    if (registerInvoices?.length && setDefault) {
      setRegisterInvoice(registerInvoices[0]);
    }
  }, [search, registerInvoices]);

  useEffect(() => {
    if (registerInvoiceId && registerInvoices && registerInvoices.length) {
      registerInvoices.forEach(registerInvoice => {
        if (registerInvoice.id === registerInvoiceId) {
          setRegisterInvoice(registerInvoice);
          if (registerInvoice?.typeCompany === 1) {
            setDisplayCrupXangDau('create');
          } else {
            setDisplayCrup(true);
          }
        }
      });
    }
  }, [registerInvoiceId, registerInvoices]);

  useEffect(() => {
    if (registerInvoice) {
      setColumnsState(0);
      setRequiredParams({ registerInvoiceId: registerInvoice.id });
      setSelectedItems(null);
      registerInvoiceViewId = registerInvoice.id;
      setRegisterId(registerInvoice.id);
      if (registerInvoice.symbolCode) {
        loadColumnConfig();
        RegisterInvoiceService.getInvoiceSettings(registerInvoice.id).then(data => {
          const _columnConfigSum = [];
          data.forEach(item => {
            if (item.groupTypeCode === '06' && item.dataType === 'int32') {
              _columnConfigSum.push({ value: item.fieldName, label: item.lable });
            }
          });
          setColumnConfigSum(_columnConfigSum);
        });
      }
    }
  }, [registerInvoice]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setRequiredParams({
      ...requiredParams,
      loadAll: false
    });
    refreshToolbar();
  }, [registerId]);

  useEffect(() => {
    if (columnConfigOrigin) {
      const _columns = [];
      columnConfigOrigin.forEach(columnOrigin => {
        if (columnOrigin.active) {
          let defaultHard: any = {};
          switch (columnOrigin.dataType) {
            case 'int32':
            case 'numeric':
              defaultHard = {
                dataType: 'custom', customCell(rowData: any): any {
                  return FormatDisplay.number(rowData[columnOrigin.field], FormatDisplay.getFractionDigits(rowData));
                }, style: { justifyContent: 'end' }
              }
              break;
            case 'dateTime':
              defaultHard = { dataType: 'date' };

              if (columnOrigin.matchMode) {
                defaultHard.filterType = 'range-date';
                if (columnOrigin.field === 'invoiceDate') {
                  defaultHard.filterField = 'fromDate@toDate';
                } else {
                  defaultHard.filterField = columnOrigin.filterField;
                }
                defaultHard.matchMode = columnOrigin.matchMode;
              }
              break;
          }
          const hard = hardColumns[columnOrigin.field] ? hardColumns[columnOrigin.field] : defaultHard;
          _columns.push({
            field: columnOrigin.field,
            header: columnOrigin.header,
            width: columnOrigin.width,
            sum: columnOrigin.sum,
            ...hard,
            matchMode: columnOrigin.matchMode
          });
        }
      });
      setColumns(_columns);
      setColumnsState(Date.now);
    }
  }, [columnConfigOrigin]); // eslint-disable-line react-hooks/exhaustive-deps

  const hardColumns = {
    invoiceStatus: {
      filterType: 'multiselect', filterOptions: Service.invoiceStatuses, dataType: 'custom', customCell(rowData: any): any {
        return <span className={`invoice-status invoice-status-${rowData.invoiceStatus}`}>{Service.invoiceStatuses[rowData.invoiceStatus]?.label}</span>;
      }
    },
    sendTaxStatus: {
      filterType: 'multiselect', filterOptions: Service.sendTaxStatuses, dataType: 'custom', customCell(rowData: any): any {
        if ([3, 4, 5].includes(rowData.sendTaxStatus)) {
          return <span className={`underline send-tax-status send-tax-status-${rowData.sendTaxStatus}`} onClick={() => showTransferLog(rowData)}>{Service.sendTaxStatuses[rowData.sendTaxStatus]?.label}</span>;
        }
        if ([1].includes(rowData.sendTaxStatus) && rowData.systemStatus > 0) {
          return <span className={`underline send-tax-status send-tax-status-1`} title={`${systemStatus[rowData.systemStatus]}`}>{Service.sendTaxStatuses[rowData.sendTaxStatus]?.label}</span>;
        }
        return <span className={`send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{Service.sendTaxStatuses[rowData.sendTaxStatus]?.label}</span>;
      }
    },
    buyerLegalName: {
      minWidth: 250, dataType: 'custom', customCell(rowData: any): any {
        return rowData.buyerLegalName || rowData.buyerDisplayName;
      }
    },
    sendEmail: { filterType: 'boolean', dataType: 'boolean' }
  };

  const setDisableIconAction = () => {
    setShowIconView(permissions.includes(ROLE.INVOICE_MANAGEMENT_EDIT));
    setShowIconCopy(permissions.includes(ROLE.INVOICE_MANAGEMENT_COPY));
    setShowIconPrint(permissions.includes(ROLE.INVOICE_MANAGEMENT_PRINT));
    setShowIconSendEmail(permissions.includes(ROLE.INVOICE_MANAGEMENT_EMAIL));
    setShowIconSign(permissions.includes(ROLE.INVOICE_MANAGEMENT_SIGN));
  }
  const loadColumnConfig = () => {
    AppConfigService.getColumnConfig({
      Serial: registerInvoice.symbolCode,
      TypeConfig: 'Invoice',
      TypeCompany: registerInvoice.typeCompany
    }).then(config => {
      const _configColumns = config.items || [];
      AppConfigService.getColumnConfigDefault(registerInvoice.id).then(configDefault => {
        configDefault.forEach(_default => {
          let _push = true;
          for (const _config of _configColumns) {
            if (_default.field === _config.field) {
              _push = false;
              break;
            }
          }
          _push && _configColumns.push(_default);
        });
      });
      setColumnConfig(_configColumns);
      setColumnConfigOrigin(_configColumns);
    });
  }

  const showTransferLog = (rowData) => {
    setTransferLogItem(rowData);
    setDisplayTransferLog(true);
  }

  const { render: renderDataTable, refreshLazyData, reloadLazyData, items, selectedItems, setSelectedItems, showSelection, clearItems } = useDataTable({
    header,
    dataKey,
    columns,
    columnsState,
    indexColumnWidth: 40,
    actionColumnWidth: 200,
    heightCalc: 190,
    requiredParams,
    getList: (params) => {
      return Service.getList(params);
    },
    initActions: (items) => {
      if (items) {
        items.forEach(item => {
          item.actions = [];
          if (showIconView) {
            item.actions.push({ icon: 'pi pi-pencil', className: 'p-button-warning', title: 'Chỉnh sửa', disabled: [2, 3, 4, 5].includes(item.sendTaxStatus), command: () => update(item) });
          }
          if (showIconCopy) {
            item.actions.push({ icon: 'pi pi-copy', className: '', title: 'Sao chép', command: () => clone(item) });
          }
          if (showIconPrint) {
            item.actions.push({ icon: 'pi pi-eye', className: '', title: 'Xem in', command: () => view(item) });
          }

          if (showIconSendEmail) {
            item.actions.push({ icon: 'pi pi-envelope', className: '', title: 'Gửi email', disabled: [5, 6].includes(item.sendTaxStatus), command: () => send(item) });
          }

          if (showIconSign) {
            item.actions.push({ icon: 'pi pi-user-edit', className: '', title: 'Ký gửi CQT', disabled: [2, 3, 4, 5].includes(item.sendTaxStatus), command: () => signItem(item) });
          }
          if (showIconHitoryChange) {
            item.actions.push({ icon: 'pi pi-clock', className: '', title: 'Xem lịch sử', command: () => viewHistory(item) });
          }
        });
      }
    },
    footerColumnGroup
  });

  useEffect(() => {
    if (columns) {
      let hasSumCol = false;
      columns.forEach(column => {
        if (column.sum) {
          hasSumCol = true;

          if (items) {
            let sumValue = 0;
            items.forEach(item => {
              if (typeof item[column.sum] === 'number' && !Number.isNaN(item[column.sum])) {
                sumValue += item[column.sum];
              }
            });
            column.sumValue = sumValue;
          }
        }
      });
      if (hasSumCol) {
        setFooterColumnGroup(<ColumnGroup>
          <Row>
            <Column style={{ minWidth: '40px', maxWidth: '40px', border: 0 }} />
            {
              columns.map((_column, index) => {
                if (_column.sum) {
                  return <Column key={index} footer={FormatDisplay.number(_column.sumValue)} style={{ justifyContent: 'end', minWidth: `${_column.width}px`, maxWidth: `${_column.width}px` }} />
                }
                return <Column key={index} style={{ minWidth: `${_column.width}px`, maxWidth: `${_column.width}px`, border: 0, borderLeft: '1px solid #dee2e6' }} />
              })
            }
            <Column style={{ minWidth: '199px', maxWidth: '199px' }} className="table-actions" />
          </Row>
        </ColumnGroup>);
      } else {
        setFooterColumnGroup(null);
      }
    } else {
      setFooterColumnGroup(null);
    }
  }, [columns, items]); // eslint-disable-line react-hooks/exhaustive-deps

  const { renderSign, sign } = useSign({ onComplete: refreshLazyData });

  const { renderImportExcel, showImportDialog } = useDialogImportExcel({
    registerInvoice,
    exportExcel: (registerInvoiceId) => {
      return Service.downloadInvoiceExcel(registerInvoiceId);
    },
    exportExcelFileName: 'hoa-don',
    importExcel: (registerInvoiceId, data) => {
      return Service.uploadInvoiceExcel(registerInvoiceId, data);
    },
    reloadLazyData: refreshLazyData
  });

  const { renderSyncInoice, showSyncInvoiceDialog } = useDialogSyncInvoice({
    registerInvoices,
    registerInvoice
  });

  const { renderChangeSerial, showChangeSerialDialog } = useDialogChangeInvoiceSerial({
    registerInvoices,
    registerInvoice
  });

  const { renderTaxAuthStatus, showTaxAuthStatus } = useDialogTaxAuthStatus({
    invoice: selectedItems, refreshLazyData
  });

  const downloadXml = () => {
    if (selectedItems && !Array.isArray(selectedItems) && selectedItems['id']) {
      downloadSingleFileXml();
    } else {
      downloadMutileFileXml();
    }
  }
  const loadAllData = () => {
    setRequiredParams({
      ...requiredParams,
      loadAll: true
    });
    refreshLazyData();
  }

  const downloadSingleFileXml = () => {
    Service.downloadInvoiceXml(selectedItems['id']).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = selectedItems['buyerTaxCode'] ? `${selectedItems['sellerTaxCode']}_${selectedItems['invoiceSerial']}_${selectedItems['invoiceNumber']}_${selectedItems['buyerTaxCode'] ? selectedItems['buyerTaxCode'] : ""}_${selectedItems['invoiceDate'] ? FormatDisplay.date(selectedItems['invoiceDate'], 'DD-MM-YYYY') : moment().format('DD-MM-YYYY')}.xml` : `${selectedItems['sellerTaxCode']}__${selectedItems['invoiceSerial']}_${selectedItems['invoiceNumber']}_${selectedItems['invoiceDate'] ? FormatDisplay.date(selectedItems['invoiceDate'], 'DD-MM-YYYY') : moment().format('DD-MM-YYYY')}.xml`;
      link.click();
    });
  }

  const downloadMutileFileXml = () => {
    let InvoiceIdArray;
    if (Array.isArray(selectedItems) && selectedItems.length) {
      InvoiceIdArray = selectedItems.map(({ id, buyerTaxCode, sellerTaxCode, invoiceSerial, invoiceNumber, invoiceDate }) => `${id}_${sellerTaxCode}_${invoiceSerial}_${(invoiceNumber ?? id)}_${buyerTaxCode ? buyerTaxCode : ""}_${invoiceDate ? FormatDisplay.date(invoiceDate, 'DD-MM-YYYY') : moment().format('DD-MM-YYYY')}`);
    } else {
      InvoiceIdArray = [`${selectedItems['id']}_${selectedItems['sellerTaxCode']}_${selectedItems['invoiceSerial']}_${selectedItems['invoiceNumber'] ?? selectedItems['id']}_${selectedItems['buyerTaxCode'] ? selectedItems['buyerTaxCode'] : ""}_${selectedItems['invoiceDate'] ? FormatDisplay.date(selectedItems['invoiceDate'], 'DD-MM-YYYY') : moment().format('DD-MM-YYYY')}`];
    }

    if (InvoiceIdArray && InvoiceIdArray.length) {
      Sign({
        "CommandName": "ExportInvoiceXML",
        "InvoiceIdArray": InvoiceIdArray
      }).then(() => {
        refreshLazyData();
      });
    }
  }

  const updateCompanyInfo = () => {
    const valid = validateUpdateItems(selectedItems);
    if (!valid) return;
    if (selectedItems) {
      let ids;
      if (Array.isArray(selectedItems) && selectedItems.length) {
        ids = selectedItems.map(({ id }) => id);
      } else {
        ids = [selectedItems['id']];
      }
      if (ids && ids.length) {
        ConfirmDialogService.confirmUpdateCompanyInfo(() => {
          Service.updateBatchCompany(ids);
          ToastService.success();
        });
      } else {
        ConfirmDialogService.showInvalid('Bạn cần chọn hóa đơn trước khi Ký');
      }
    }
  }

  const validateUpdateItems = (items) => {
    let _valid = true, ivs = [];
    if (items['id']) {
      ivs = [items];
    } else {
      ivs = [...items];
    }
    for (const iv of ivs) {
      if ([2, 3, 4, 5].includes(iv.sendTaxStatus)) {
        _valid = false;
        ConfirmDialogService.showInvalid('Chỉ được phép thao tác với hóa đơn Chờ ký');
        break;
      }
    }
    return _valid;
  }
  const reloadAuthorisedCode = () => {
    MGateWayService.reloadAuthorisedCode({
      registerInvoiceId: registerId,
    }).then(data => {
      refreshLazyData();
    });
  }
  const update = (item) => {
    setSelectedItems(item);
    setInvoiceStatus(null);
    if (item?.registerInvoiceId) {
      const _registerInvoice = registerInvoices.find(it => it.id === item.registerInvoiceId);
      if (_registerInvoice?.typeCompany === 1 && ![2, 3].includes(item.invoiceStatus)) {
        return setDisplayCrupXangDau('update');
      }
    }
    setDisplayCrup(true);
  }

  const clone = (item) => {
    const _item = Object.assign({}, item);
    _item.isClone = true;
    _item.invoiceStatus = 0;
    setInvoiceStatus(null);
    setSelectedItems(_item);
    if (item?.registerInvoiceId) {
      const _registerInvoice = registerInvoices.find(it => it.id === item.registerInvoiceId);
      if (_registerInvoice?.typeCompany === 1) {
        return setDisplayCrupXangDau('clone');
      }
    }
    setDisplayCrup(true);
  }

  const view = (item) => {
    setSelectedItems(item);
    setDisplayView(true);
  }

  const onAddSelectedItems = (items) => {
    let InvoiceIdArray;
    if (Array.isArray(items) && items.length) {
      InvoiceIdArray = items.map(({ id }) => id);
    }

    if (!InvoiceIdArray || InvoiceIdArray.length < 1) {
      ConfirmDialogService.showInvalid('Bạn cần chọn hóa đơn trước khi Ký');
      return;
    }

    sign({
      "CommandName": "SignInvoices",
      "InvoiceIdArray": InvoiceIdArray
    });
  }

  const chunkArray = (array, size) => {
    const result = []
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size))
    }
    return result
  }


  const viewHistory = (item) => {
    setDisplayHistoryItem(item);
    setDisplayHistory(true);
  }

  const send = (item) => {
    setSelectedItems(item);
    setDisplaySendEmail(true);
  }

  const signItem = (item) => {
    sign({
      "CommandName": "SignInvoices",
      "InvoiceIdArray": [item['id']]
    });
  }

  useEffect(() => {
    const reloadData = () => {
      refreshLazyData();
    }

    const syncInvoice = (syncInvoiceData) => {
      if (syncInvoiceData.usePlugin) {
        syncByPlugin(syncInvoiceData);
      } else {
        syncByWebApp(syncInvoiceData);
      }
    }

    const changeSerial = (changeSerialData) => {
      const itemChange = registerInvoices.find((t) => t.symbolCode == changeSerialData.invoiceSerialRepalce);
      Service.createChangeSerial(changeSerialData).then(res => {
        setRegisterInvoice(itemChange);
        refreshLazyData();
      });
    }
    const showDialogSendEmail = (dataInvoice) => {
      setSelectedItems(dataInvoice);
      setDisplaySendEmail(true);
    };

    const eventsSyncInvoice = EventEmitter.addListener("syncInvoiceData", syncInvoice);
    const eventsListner = EventEmitter.addListener("reloadInvoiceData", reloadData);
    const eventsChangeSerial = EventEmitter.addListener("changeInvoiceSerial", changeSerial);
    const eventsshowDialogSendEmail = EventEmitter.addListener("showDialogSendEmail", showDialogSendEmail);
    return () => {
      eventsListner.removeListener("reloadInvoiceData", reloadData);
      eventsSyncInvoice.removeListener("syncInvoiceData", syncInvoice);
      eventsChangeSerial.removeListener("changeInvoiceSerial", changeSerial);
      eventsshowDialogSendEmail.removeListener("showDialogSendEmail", showDialogSendEmail);
    }
  });

  const syncByPlugin = (data) => {
    Sign({
      "CommandName": "SyncInvoiceData",
      "InvoiceSysnDto": data
    }).then(() => {
      refreshLazyData();
    });
  };

  const syncByWebApp = (data) => {
    Service.createSyncInvoice(data).then(res => {
      refreshLazyData();
    });
  };

  const [manyActions, setManyActions] = useState([]);

  useEffect(() => {
    const actionsOther = [];
    if (showSelection) {
      if (showIconPrint) {
        actionsOther.push({
          label: 'Tải hóa đơn PDF', icon: 'pi pi-fw pi-download', className: 'iam-toolbar iam-toolbar-success', command: () => {
            if (selectedItems && selectedItems['id']) {
              setDisplayView(true);
            } else if (selectedItems && selectedItems.length) {
              let InvoiceIdArray;
              if (Array.isArray(selectedItems) && selectedItems.length) {
                InvoiceIdArray = selectedItems.map(({ id }) => id);
              } else {
                InvoiceIdArray = [selectedItems['id']];
              }
              if (InvoiceIdArray && InvoiceIdArray.length) {
                Sign({
                  "CommandName": "ExportInvoice",
                  "InvoiceIdArray": InvoiceIdArray
                }).then(() => {
                  refreshLazyData();
                });
              }
            } else {
              ConfirmDialogService.showInvalid('Bạn cần chọn hóa đơn trước khi Xem in');
            }
          }
        });

        actionsOther.push({
          label: 'Xem in', icon: 'pi pi-fw pi-print', className: 'iam-toolbar iam-toolbar-success', command: () => {
            if (selectedItems) {
              setDisplayViewMulti(true);
            } else {
              ConfirmDialogService.showInvalid('Bạn cần chọn hóa đơn trước khi Xem in');
            }
          }
        });
      }

      if (showIconSign) {
        actionsOther.push({
          label: 'Ký gửi CQT', icon: 'pi pi-fw pi-user-edit', className: 'iam-toolbar', command: () => {
            if (selectedItems) {
              let InvoiceIdArray;
              if (Array.isArray(selectedItems) && selectedItems.length) {
                InvoiceIdArray = selectedItems.map(({ id }) => id);
              } else {
                InvoiceIdArray = [selectedItems['id']];
              }
              if (InvoiceIdArray && InvoiceIdArray.length) {
                sign({
                  "CommandName": "SignInvoices",
                  "InvoiceIdArray": InvoiceIdArray
                });
              } else {
                ConfirmDialogService.showInvalid('Bạn cần chọn hóa đơn trước khi Ký');
              }
            }
          }
        });
      }

      if (showIconSendEmail) {
        actionsOther.push({
          label: 'Gửi email', icon: 'pi pi-fw pi-send', className: 'iam-toolbar iam-toolbar-success', command: () => {
            let hasItems = false;
            if (selectedItems) {
              if (Array.isArray(selectedItems) && selectedItems.length) {
                hasItems = true;
              } else if (selectedItems['id']) {
                hasItems = true;
              }
            }
            if (hasItems) {
              setDisplaySendEmail(true);
            } else {
              ConfirmDialogService.showInvalid('Bạn cần chọn hóa đơn trước khi Gửi email');
            }
          }
        });
      }
    }

    setManyActions(actionsOther);
    refreshToolbar();
  }, [selectedItems]); // eslint-disable-line react-hooks/exhaustive-deps

  const op = useRef(null);

  const onRowReorder = e => {
    setColumnConfig(e.value);
  }

  const restoreColumnConfig = () => {
    AppConfigService.restoreColumnConfig({
      Serial: registerInvoice.symbolCode,
      TypeCompany: registerInvoice.typeCompany,
      TypeConfig: 'Invoice'
    }).then(() => {
      loadColumnConfig();
    });
  }
  const saveColumnConfig = () => {
    AppConfigService.setColumnConfig({
      Serial: registerInvoice.symbolCode,
      TypeConfig: 'Invoice',
      TypeCompany: registerInvoice.typeCompany,
      detail: columnConfig
    }).then(() => {
      loadColumnConfig();
    });
  }

  let itemFunctionAction = [];
  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_FEATURES_UPLOADEXCEL)) {
    itemFunctionAction.push({ label: 'Nhận Excel', command: showImportDialog });
  }

  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_FEATURES_DOWNLOADXML)) {
    itemFunctionAction.push({ label: 'Tải XML', command: downloadXml });
  }

  // if (permissions.includes(ROLE.INVOICE_MANAGEMENT_FEATURES_UPLOADEXCEL)) {
  //   itemFunctionAction.push({label: 'Đồng bộ hóa đơn', command: showSyncInvoiceDialog});
  // }  


  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_FEATURES_UPLOADEXCEL)) {
    itemFunctionAction.push({ label: 'Chuyển ký hiệu', command: showChangeSerialDialog });
  }
  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_EDIT)) {
    itemFunctionAction.push({
      label: 'Cập nhật thông tin bên bán', command: () => {
        updateCompanyInfo();
      }
    });
  }


  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_EDIT)) {
    itemFunctionAction.push({ label: 'Cập nhật trạng thái HĐ từ CQT', command: showTaxAuthStatus });
  }

  if (itemFunctionAction && itemFunctionAction.length) {
    functionActions.push({
      label: 'Chức năng', icon: 'pi pi-fw pi-th-large', className: 'iam-toolbar iam-toolbar-help',
      items: [[
        {
          label: '',
          items: [...itemFunctionAction]
        }
      ]]
    });
  }

  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_SIGN)) {
    mitileSignActions.push({
      label: 'Ký hóa đơn hàng loạt', icon: 'p-button-icon p-c pi pi-user-edit', className: 'iam-toolbar', command: () => {
        setDisplaySelectInvoice(true);
      }
    });
  }


  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_SIGN)) {
    mitileSignActions.push({
      label: 'Lấy mã cơ quan thuế', icon: 'p-button-icon p-c pi pi-search', className: 'iam-toolbar', command: () => {
        ConfirmDialogService.confirmReloadAuthorisedCode(() => {
          reloadAuthorisedCode();
        });
      }
    });
  }

  let itemErrorProcessingAction = [];
  // if (permissions.includes(ROLE.INVOICE_MANAGEMENT_ERRORPROCESSING_CANCEL)) {
  //   itemErrorProcessingAction.push({
  //     label: 'Huỷ hoá đơn', command: () => {
  //       if (selectedItems.length || selectedItems['id']) {
  //         let _DisplayCancel = true, ivs = [];
  //         if (selectedItems['id']) {
  //           ivs = [selectedItems];
  //         } else {
  //           ivs = [...selectedItems];
  //         }
  //         for (const iv of ivs) {
  //           if (![0, 4].includes(iv.invoiceStatus) || ![4].includes(iv.sendTaxStatus)) {
  //             _DisplayCancel = false;
  //             ConfirmDialogService.showInvalid('Bạn chỉ được Hủy hóa đơn ký gửi thành công ở trạng thái Gốc - Giải trình');
  //             break;
  //           }
  //         }
  //         if (_DisplayCancel) {
  //           setDisplayCancel(true);
  //         }
  //       }
  //     }
  //   });
  // }

  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_ERRORPROCESSING_SUBSTITUTE)) {
    itemErrorProcessingAction.push({
      label: 'Thay thế', command: () => {
        if (selectedItems && selectedItems['id']) {
          if (![0, 3].includes(selectedItems['invoiceStatus']) || ![2, 4].includes(selectedItems['sendTaxStatus'])) {
            ConfirmDialogService.showInvalid('Bạn chỉ được Thay thế hóa đơn ký gửi thành công ở trạng thái Gốc hoặc Thay thế');
          } else {
            setInvoiceStatus(3);
            setDisplayCrup(true);
          }
        }
      }
    });
  }

  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_ERRORPROCESSING_ADJUSTMENT)) {
    itemErrorProcessingAction.push({
      label: 'Điều chỉnh', command: () => {
        if (selectedItems && selectedItems['id']) {
          if (selectedItems && selectedItems['id']) {
            if (![0, 5].includes(selectedItems['invoiceStatus']) || ![2, 4].includes(selectedItems['sendTaxStatus'])) {
              ConfirmDialogService.showInvalid('Bạn chỉ được Điều chỉnh hóa đơn ký gửi thành công ở trạng thái Gốc hoặc Bị điều chỉnh');
            } else {
              setInvoiceStatus(2);
              setDisplayCrup(true);
            }
          }
        }
      }
    });
  }

  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_ERRORPROCESSING_SUBSTITUTET32)) {
    itemErrorProcessingAction.push({
      label: 'Thay thế HĐ trên hệ thống khác', command: () => {
        setSelectedItems(null);
        setInvoiceStatus(3);
        setDisplayCrup(true);
      }
    });
  }

  if (permissions.includes(ROLE.INVOICE_MANAGEMENT_ADJUSTMENTT32)) {
    itemErrorProcessingAction.push({
      label: 'Điều chỉnh HĐ trên hệ thống khác', command: () => {
        setSelectedItems(null);
        setInvoiceStatus(2);
        setDisplayCrup(true);
      }
    });
  }

  if (itemErrorProcessingAction && itemErrorProcessingAction.length) {
    errorProcessingAction.push({
      label: 'Xử lý sai sót', icon: 'pi pi-fw pi-server', className: 'iam-toolbar iam-toolbar-help w-15',
      items: [[
        {
          label: '',
          items: [...itemErrorProcessingAction],
        }
      ]]
    });
  }
  errorProcessingAction.push({
    label: 'Xem toàn bộ HĐ', icon: 'p-button-icon p-c pi pi-filter', className: 'iam-toolbar', command: loadAllData
  });

  const { renderToolbar, refreshToolbar } = useToolbar({
    dataKey,
    createRole,
    editRole,
    cloneRole,
    deleteRole,
    importRole,
    exportRole,
    create: () => {
      setSelectedItems(null);
      setInvoiceStatus(null);
      if (registerInvoice?.typeCompany === 1) {
        setDisplayCrupXangDau('create');
      } else {
        setDisplayCrup(true);
      }
    },
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    deleteItems: (ids) => {
      return Service.deleteBatch(ids);
    },
    validateDeleteItems: (items) => {
      let _valid = true, ivs = [];
      if (items['id']) {
        ivs = [items];
      } else {
        ivs = [...items];
      }
      for (const iv of ivs) {
        if ([2, 3, 4, 5].includes(iv.sendTaxStatus)) {
          _valid = false;
          ConfirmDialogService.showInvalid('Bạn không được Xóa hóa đơn Đã ký, Đã gửi, Thành Công, Có lỗi');
          break;
        }
      }
      return _valid;
    },
    otherActions: [
      ...manyActions,
      ...functionActions,
      ...mitileSignActions,
      ...errorProcessingAction,
      // {
      //   label: 'Thêm HĐ chiết khấu',
      //   icon: 'pi pi-fw pi-plus',
      //   className: 'iam-toolbar',
      //   command: () => setDisplayDiscountInvoiceAttachment(true)
      // }
    ],
    endMenu: <Fragment>
      <Button icon="pi pi-cog" className="p-button-rounded p-button-outlined p-button-secondary" onClick={e => op.current.toggle(e)} />
      <OverlayPanel ref={op} style={{ width: '600px' }}>
        <DataTable value={columnConfig} reorderableRows onRowReorder={onRowReorder}
          scrollable scrollHeight="50vh" responsiveLayout="scroll" className="p-fluid" size={'small'}>
          <Column body={(rowData, { rowIndex }) =>
            <Checkbox checked={rowData.active} onChange={e => onColumnConfigChange(rowIndex, 'active', e.checked)} />}
            style={{ minWidth: '2em', maxWidth: '2em' }} />
          <Column field="header" header="Tên cột" />
          <Column field="width" header="Độ rộng (px)" body={(rowData, { rowIndex }) =>
            <InputNumber locale={FormatDisplay.locales} value={rowData.width} min={10} max={500} onValueChange={e => onColumnConfigChange(rowIndex, 'width', e.value)} />}
            style={{ minWidth: '8em', maxWidth: '8em' }} />
          <Column field="sum" header="Tổng cộng" body={(rowData, { rowIndex }) =>
            <Dropdown value={rowData.sum} options={columnConfigSum} onChange={e => onColumnConfigChange(rowIndex, 'sum', e.value)} showClear style={{ width: '100%' }} />}
            style={{ minWidth: '17em', maxWidth: '17em' }} />
          <Column rowReorder style={{ minWidth: '4em', maxWidth: '4em' }} />
        </DataTable>
        <div className="text-right mt-4">
          <Button label="Lấy lại mặc định" className="p-button-text p-button-sm mr-2" onClick={restoreColumnConfig} />
          <Button label="Lưu" icon="pi pi-check" className="p-button-sm" onClick={saveColumnConfig} />
        </div>
      </OverlayPanel>
    </Fragment>
  });

  const onColumnConfigChange = (rowIndex, field, value) => {
    const _columnConfig = [...columnConfig];
    _columnConfig[rowIndex][field] = value;
    setColumnConfig(_columnConfig);
  }

  return (
    <Fragment>
      <div className="p-fluid formgrid grid">
        <div className="col-4">
          <Dropdown value={registerInvoice} options={registerInvoices} onChange={e => setRegisterInvoice(e.value)} dataKey="id" filter={true} />
        </div>
      </div>
      {renderToolbar()}
      {renderDataTable()}
      {renderImportExcel()}
      {renderSyncInoice()}
      {renderChangeSerial()}
      {renderTaxAuthStatus()}
      {renderSign()}

      <DialogCrup display={displayCrup} setDisplay={setDisplayCrup} reloadLazyData={refreshLazyData}
        registerInvoices={registerInvoices} currencies={currencies} paymentTypes={paymentTypes}
        registerInvoice={registerInvoice} selectedItem={selectedItems} invoiceStatus={invoiceStatus} setInvoiceStatus={setInvoiceStatus}
        sign={sign} showIconSign={showIconSign} idInvoiceListDiscount={idInvoiceListDiscount} setSelectedItems={setSelectedItems}
        setDisplayDiscountInvoiceAttachment={setDisplayDiscountInvoiceAttachment}
        relatedInvoiceProperty={relatedInvoiceProperty}
        setRelatedInvoiceProperty={setRelatedInvoiceProperty}
        setIdInvoiceListDiscount={setIdInvoiceListDiscount}
      />
      <DialogCrupXangDau display={displayCrupXangDau} setDisplay={setDisplayCrupXangDau} view={view}
        currencies={currencies} paymentTypes={paymentTypes} registerInvoice={registerInvoice}
        selectedItems={selectedItems}
        refreshLazyData={refreshLazyData} sign={sign} />
      <DialogView display={displayView} setDisplay={setDisplayView} selectedItem={selectedItems}
        setDisplayCancel={setDisplayCancel} setInvoiceStatus={setInvoiceStatus} setDisplayCrup={setDisplayCrup} sign={sign} />
      <DialogViewMulti display={displayViewMulti} setDisplay={setDisplayViewMulti} selectedItem={selectedItems}
        setDisplayCancel={setDisplayCancel} setInvoiceStatus={setInvoiceStatus} setDisplayCrup={setDisplayCrup} />
      <DialogCancel display={displayCancel} setDisplay={setDisplayCancel} selectedItems={selectedItems} />
      <DialogSendEmail display={displaySendEmail} setDisplay={setDisplaySendEmail} sendType={sendType} selectedItems={selectedItems} />
      <DialogViewTransferLog display={displayTransferLog} setDisplay={setDisplayTransferLog} selectedItem={transferLogItem} />
      <DialogViewHistory display={displayHistory} setDisplay={setDisplayHistory} selectedItem={displayHistoryItem} />
      <DialogSignInvoice display={displaySelectInvoice} setDisplay={setDisplaySelectInvoice} addSelectedItems={onAddSelectedItems} selectionMode="checkbox"
        invoiceStatus="" sendTaxStatus="1" registerInvoice={registerInvoice} perPageOptions="[100,200,300]" />
      <DialogSelectInvoiceDiscounted
        display={displaySelectInvoiceDiscounted}
        setDisplay={setDisplaySelectInvoiceDiscounted}
        addSelectedItems={(data) => {
          const items = [
            ...selectInvoiceDiscounted,
            ...data.filter(
              (newItem) =>
                !selectInvoiceDiscounted.some(
                  (existingItem) => existingItem.id === newItem.id
                )
            ),
          ]
          if (!items.every(val => val.invoiceSerial === items[0].invoiceSerial)) {
            return ToastService.error('Chỉ được chọn các hóa đơn có cùng ký hiệu')
          }
          if (!items.every(val => val.buyerTaxCode === items[0].buyerTaxCode)) {
            return ToastService.error('Chỉ được chọn các hóa đơn có cùng mã số thuế')
          }
          setSelectInvoiceDiscounted(items)
          setSelectedItems(null)
          setDisplayDiscountInvoiceAttachment(true)
          setDisplaySelectInvoiceDiscounted(false);

        }}
        registerInvoice={registerInvoice}
      />
      <DialogDiscountInvoiceAttachment
        invoices={selectInvoiceDiscounted}
        setInvoices={setSelectInvoiceDiscounted}
        display={displayDiscountInvoiceAttachment}
        setDisplay={setDisplayDiscountInvoiceAttachment}
        setDisplaySelectInvoiceDiscounted={setDisplaySelectInvoiceDiscounted}
        setDisplayCrup={setDisplayCrup}
        setInvoiceStatus={setInvoiceStatus}
        setSelectedItems={setIdInvoiceListDiscount}
        setRelatedInvoiceProperty={setRelatedInvoiceProperty}
      />
      {/* <DialogInvoiceListDiscount/> */}
    </Fragment>
  )
}
